import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import RegisterPage from './components/RegisterPage';
import SuccessPage from './components/SuccessPage';

const App = () => {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<RegisterPage />} />
          <Route path='success' element={<SuccessPage />} />
        </Routes>
      </Layout>
    </Router>
  );
};

export default App;
